// pages/UserManagementFormPage.jsx

import React from "react";
import StatusProductForm from "../components/StatusProductForm";

function StatusProductFormPage() {
  return (
    <div>
      <StatusProductForm />
    </div>
  );
}

export default StatusProductFormPage;
